// extracted by mini-css-extract-plugin
export default {"imageWrapper":"bG-z","twoColumnImage":"cG-z"};